module.exports = __webpack_public_path__ + "img/walkthrough_illust24@2x.61e96f66.png";